<template>
	<div style="padding: 10px 10px 10px 0;">
		<el-dialog :title="title" :visible.sync="show" width="30%">
			<el-form ref="form" :model="form" label-width="100px">
				<el-form-item label="所属楼层">
					<el-select :disabled="title[0]=='查'" v-model="form.storey" placeholder="所属楼层">
						<el-option v-for="item in 5" :label="`${item}楼`" :value="`${item}楼`"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="联系人">
					<el-input :disabled="title[0]=='查'" v-model="form.linkName"></el-input>
				</el-form-item>
				<el-form-item label="联系电话">
					<el-input :disabled="title[0]=='查'" v-model="form.linkPhone"></el-input>
				</el-form-item>
				<el-form-item label="身份证号">
					<el-input :disabled="title[0]=='查'" v-model="form.linkCard"></el-input>
				</el-form-item>
				<el-form-item label="商铺状态">
					<el-select :disabled="title[0]=='查'" v-model="form.status">
						<el-option label="正常" value="正常"></el-option>
						<el-option label="停用" value="停用"></el-option>
					</el-select>

				</el-form-item>
				<el-form-item label="水仪表编码">
					<el-input :disabled="title[0]=='查'" v-model="form.waterCode"></el-input>
				</el-form-item>
				<el-form-item label="电仪表编码">
					<el-input :disabled="title[0]=='查'" v-model="form.electricityCode"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="show = false">取 消</el-button>
				<el-button v-if="title[0]!='查'" type="primary" @click="ok">确 定</el-button>
			</span>
		</el-dialog>
		<el-form :inline="true" :model="selectForm" class="demo-form-inline">
			<div class="flex sb">
				<div>
					<el-form-item label="商铺号">
						<el-input v-model="selectForm.shopNum" placeholder="商铺号" clearable></el-input>
					</el-form-item>
					<el-form-item label="对账状态">
						<el-select v-model="selectForm.status">
							<el-option label="未对账" value="1"></el-option>
							<el-option label="已对账" value="2"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="付款方名称">
						<el-input v-model="selectForm.name" placeholder="付款方名称" clearable></el-input>
					</el-form-item>
					<el-form-item label="商铺号">
						<el-input v-model="selectForm.shopNum" placeholder="商铺号" clearable></el-input>
					</el-form-item>
					<el-form-item label="开始时间">
						<el-date-picker v-model="form.startTime" type="date" placeholder="开始时间" style="width: 150px;">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="结束时间">
						<el-date-picker v-model="form.endTime" type="date" placeholder="结束时间" style="width: 150px;">
						</el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="getAll()">查询</el-button>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="dc">导出</el-button>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="addTemplate">下载对账单导入模板</el-button>
					</el-form-item>
					<el-form-item>
						<el-upload action="/api/admin/reconciliation/importReconciliation" name="file" :show-file-list="false"
							:headers="headers" :on-success="success">
							<el-button type="primary">导入对账单</el-button>
						</el-upload>
					</el-form-item>

				</div>

			</div>
		</el-form>
		<el-table :data="data" style="width: 100%" border>
			<el-table-column prop="serialNum" label="交易流水号"></el-table-column>
			<el-table-column prop="name" label="付款方名称"></el-table-column>
			<el-table-column prop="dateTimes" label="日期"></el-table-column>
			<el-table-column prop="amount" label="金额"></el-table-column>


			<el-table-column prop="shopNum" label="商铺编号"></el-table-column>
			<el-table-column prop="state" label="对账状态">
				<template slot-scope="{row}">
					{{row.state==1?'未对账':'已对账'}}
				</template>
			</el-table-column>
			<el-table-column prop="reconciled" label="已对账金额"></el-table-column>
			<el-table-column prop="surplus" label="未对账金额"></el-table-column>
			<el-table-column prop="date" label="操作">
				<template slot-scope="{row}">
					<!-- <el-button type="text" @click="setRow(row,'1')">详情</el-button> -->
					<el-button type="text" @click="setRow(row)">编辑</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination :page-sizes="[10, 20, 30, 50]" :page-size="selectForm.pageSize"
			layout="total, sizes, prev, pager, next, jumper" :total="count" @size-change="handleSizeChange"
			@current-change="handleCurrentChange">
		</el-pagination>

	</div>
</template>

<script>
	import publicExport from '../../assets/js/publicExport.js';
	export default {
		data() {
			return {
				title: "新增",
				count: 0,
				headers: {
					Authorization: localStorage.access_token
				},

				show: false,
				selectForm: {
					name: null,
					currentPage: 1,
					pageSize: 10,
					shopNum: null, //商铺号
					startTime: null, //楼层
					endTime: null,
					state: null
				},
				oldForm: "",
				form: {
					"storey": "", //楼层
					linkName: '',
					linkPhone: '',
					linkCard: '',
					status: '',
					waterCode: '',
					electricityCode: ''
				},
				data: [],
				isFail: false,
				czList: [],
			}
		},
		methods: {
			tb() {
				this.$http.post("/api/shop/code/init", {}).then(res => {
					console.log(res)
					if (res.data.code == 0) {
						this.getAll()
						this.$message.success(res.data.message)
					} else {
						this.$message.error(res.data.message)

					}
				}).catch(err => {

				})
			},
			addTemplate() { //下载导入模板
				this.$http.post(`/api/reconciliation/downloadReconciliationTemplate`, {}, {
					headers: {
						Accept: "application/json",
						"Content-Type": "application/json;charset=utf-8",
					},
					responseType: "blob"
				}).then(res => {
					const link = document.createElement("a");
					let blob = new Blob([res.data], {
						type: "application/vnd.ms-excel"
					});
					link.style.display = "none";
					link.href = URL.createObjectURL(blob);
					link.download = "对账单导入模板.xls";
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
				})
			},
			success(res) {
				if (res.code == 0) {
					this.getAll()
					this.$message.success("导入成功")
				} else {
					this.$message.error(res.message)
					this.isFail = true
					this.czList = res.data
				}
			},
			setRow(obj) {
				this.$router.push({
					name:'系统对账详情',
					params:{
						obj
					}
				})

			},
			dc() {
				publicExport("/api/reconciliation/exportReconciliation", this.selectForm, "对账信息")
			},
			ok() {
				let url = "/api/bdShop/addShop"
				if (this.title == "编辑") {
					url = "/api/bdShop/updateShop"
				}
				this.$http.post(url, this.form).then(res => {
					if (res.data.code == 0) {
						this.getAll()
						this.show = false
						this.$message.success(`${this.title}成功`)
					} else {
						this.$message.error(res.data.message)
					}
				})
			},
			addRow() {
				this.form = JSON.parse(JSON.stringify(this.oldForm))
				this.title = "新增"
				this.show = true;
			},
			getAll() {
				this.$http.post("/api/reconciliation/query", this.selectForm).then(res => {
					console.log('items:',JSON.stringify(res))
					this.data = res.data.data.items
					this.count = res.data.data.totalNum
				})
			},
			handleClick() {
				this.getAll()
			},
			handleCurrentChange(val) {
				this.selectForm.currentPage = val;
				this.getAll()
			},
			handleSizeChange(val) {
				this.selectForm.pageSize = val;
				this.getAll()
			},
		},
		created() {
			this.oldForm = JSON.parse(JSON.stringify(this.form))
			this.getAll();
		}
	}
</script>

<style scoped="scoped">
</style>
